/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { reservationReady } from '@/model/dataLayer/service/otherService'

export const restaurantMenu = [
  {
    group: '/statistic',
    desc: 'DataOverviewDesc',
    icon: 'mdi-view-dashboard',
    iconFx: 'mdi-view-dashboard-outline',
    title: 'BusinessDataOverview',
    children: [
      {
        icon: 'mdi-view-dashboard',
        title: 'dashboard',
        to: 'overview'
      }
    ]
  },
  {
    group: '/billAndReport',
    desc: 'TakeawayDesc',
    icon: 'mdi-note-text-outline',
    iconFx: 'mdi-note-text-outline',
    title: 'BillingReporting',
    children: [
      {
        title: 'bill',
        icon: 'mdi-clipboard-list',
        to: 'history-bills'
      }, {
        title: 'cashBook',
        icon: 'mdi-cash-register',
        to: 'cashbook'
      },
      {
        title: 'cashAccount',
        icon: 'mdi-cash-register',
        to: 'cashAccount'
      },
      {
        title: 'VoucherStatistic',
        icon: 'mdi-smart-card-outline',
        to: 'voucherStatistic'
      }, {
        title: 'SalesStatistics',
        icon: 'mdi-sale-outline',
        to: 'salesStatistics'
      },
      {
        title: 'AttributeStatistik',
        icon: 'mdi-sale-outline',
        to: 'attributeStatistics'
      },
      {
        // needWifi: true,
        title: 'profitAnalysis',
        icon: 'mdi-chart-line',
        to: 'analysis'
      },
      {
        title: 'AdvancedAnalysis',
        icon: 'mdi-chart-line',
        to: 'simpleAnalysis'
      },
      {
        title: 'EmployeeStatistics',
        icon: 'mdi-chart-line',
        to: 'staffStatistics'
      },
      {
        title: 'staffRecords',
        icon: 'mdi-chart-line',
        to: 'staffRecords'
      },
      {
        title: 'ShiftTracking',
        icon: 'mdi-chart-line',
        to: 'worksRecords'
      },
      {
        title: 'TimeRangeStatistics',
        icon: 'mdi-chart-line',
        to: 'hourlyStatistics'
      },
      {
        title: 'DailySalesStatistics',
        icon: 'mdi-chart-line',
        to: 'dailyStatistics'
      },
      {
        title: 'ClassificationStatistics',
        icon: 'mdi-chart-line',
        to: 'categoryStatistics'
      },
      {
        title: 'statisticalReport',
        icon: 'mdi-chart-line',
        to: 'categoryReport'
      },
      {
        icon: 'mdi-file-find',
        title: 'print_bill_list',
        to: 'printRecordlist'
      },
      // {
      //   title: 'exportAndPrint',
      //   icon: 'mdi-table-arrow-right',
      //   to: 'export',
      // },
      {
        title: 'exportAndPrint',
        icon: 'mdi-table-arrow-right',
        to: 'newExport'
      },
      {
        title: 'ItalyZ-Report',
        icon: 'mdi-credit-card-edit',
        to: 'ItalyZBon'
      },
      {
        title: 'ItalyXML',
        icon: 'mdi-credit-card-edit',
        to: 'ItalyXML'
      },
      {
        title: 'ZBonList',
        icon: 'mdi-credit-card-edit',
        to: 'ZBonList'
      },
      {
        title: 'operationRecords',
        icon: 'mdi-credit-card-edit',
        to: 'OperationLog'
      },
      {
        title: 'SettlementList',
        icon: 'mdi-credit-card-edit',
        to: 'Settlement'
      },
      {
        title: 'CashBox',
        icon: 'mdi-credit-card-edit',
        to: 'CashBox'
      },
      {
        title: 'MilkTeaMachine',
        icon: 'mdi-credit-card-edit',
        to: 'MilkTea'
      }
      // {
      //   title: 'InventoryLog',
      //   icon: 'mdi-credit-card-edit',
      //   to: 'InventoryLog'
      // },

    ]
  },
  {
    group: '/dishes',
    desc: 'ProductDesc',
    icon: 'mdi-book',
    iconFx: 'mdi-book-outline',
    title: 'product',
    children: [
      {
        title: 'category',
        icon: 'mdi-label',
        to: 'labels-manage'
      },
      {
        title: 'productInfo',
        icon: 'mdi-food-fork-drink',
        to: 'dishes-manage'
      },
      {
        title: 'attribute',
        icon: 'mdi-food',
        to: 'attribute-group',
        notSupermarket: true
      },
      {
        title: 'allergName',
        icon: 'mdi-peanut-off',
        notSupermarket: true,
        to: 'allergen-setting'
      },
      {
        title: 'discountRule',
        icon: 'mdi-ticket-percent',
        to: 'discount-rules-setting'
      },
      {
        title: 'menu',
        icon: 'mdi-silverware',
        to: 'buffet-child-setting',
        notSupermarket: true
      },
      {
        title: 'HotPotSettings',
        icon: 'mdi-silverware',
        to: 'hotpot',
        notSupermarket: true
      },
      {
        title: 'vouchersManage',
        icon: 'mdi-smart-card-outline',
        to: 'voucherManage'
      }
    ]
  },
  {
    group: '/reserve',
    desc: '',
    icon: 'mdi-calendar-month',
    iconFx: 'mdi-calendar-month-outline',
    notSupermarket: true,
    title: 'reserveSetting',
    children: [
      {
        title: 'reserveSetting',
        icon: 'mdi-calendar-month',
        to: 'reserveSetting'
      }
    ]
  },
  {
    group: '/takeaway',
    desc: '',
    icon: 'mdi-truck-fast',
    iconFx: 'mdi-truck-fast-outline',
    notSupermarket: true,
    title: 'PickUpAndDeliveryService',
    children: [
      {
        title: 'PickUpAndDeliveryService',
        icon: 'mdi-calendar-month',
        to: 'takeaway'
      }
    ]
  },
  {
    group: '/qrScan',
    desc: '',
    icon: 'mdi-qrcode',
    iconFx: 'mdi-qrcode',
    notSupermarket: true,
    title: 'qrScan',
    children: [
      {
        title: 'qrScan',
        icon: 'mdi-qrcode',
        to: 'qrScan'
      }
    ]
  },
  {
    group: '/storage',
    desc: 'StorageDesc',
    icon: 'mdi-book-multiple',
    iconFx: 'mdi-book-multiple-outline',
    authCode: ProductCodes.inventory,
    title: 'storage',
    children: [
      {
        title: 'storage',
        icon: 'mdi-package-variant-closed',
        to: 'storage'
      }
    ]
  },
  {
    group: '/storeInfo',
    desc: '',
    icon: 'mdi-home',
    iconFx: 'mdi-home',
    title: 'restaurantInfo',
    children: [
      {
        title: 'restaurantInfo',
        icon: 'mdi-store-cog-outline',
        to: 'restaurant-info'
      }
    ]
  },
  // {
  //   group: '/branding',
  //   desc: '',
  //   icon: 'mdi-file-tree',
  //   iconFx: 'mdi-file-tree',
  //   title: 'storeBranding',
  //   children: [
  //     {
  //       title: 'Branding',
  //       icon: 'mdi-store-cog-outline',
  //       to: 'branding'
  //     }
  //   ]
  // },
  {
    group: '/settings',
    desc: 'SettingDesc',
    icon: 'mdi-cog',
    iconFx: 'mdi-cog-outline',
    title: 'setting',
    children: [
      // {
      //   title: 'openTime',
      //   icon: 'mdi-calendar-check-outline',
      //   to: 'openTime',
      // },
      {
        title: 'tableManage',
        icon: 'mdi-table-chair',
        to: 'Tables/tables-manage'
      },
      // {
      //   title: 'pay',
      //   icon: 'mdi-credit-card-edit',
      //   to: 'TakeawaySetting/paymentpage',
      // },
      // {
      //   title: 'ElectronicBill',
      //   icon: 'mdi-credit-card-edit',
      //   to: 'ElectronicBillingSetting',
      // },
      {
        title: 'staff',
        icon: 'mdi-book-account',
        to: 'person-manage'
      },
      // {
      //   title: 'TaxSetting',
      //   icon: 'mdi-credit-card-edit',
      //   to: 'tax-setting',
      // },
      {
        title: 'TaxType',
        icon: 'mdi-credit-card-edit',
        to: 'tax-type'
      },
      {
        title: 'PrintManagement',
        icon: 'mdi-credit-card-edit',
        to: 'print'
      },
      {
        title: 'BannerCarouselSettings',
        icon: 'mdi-credit-card-edit',
        to: 'ImgSetting'
      },
      {
        title: 'SystemConfig',
        icon: 'mdi-credit-card-edit',
        to: 'configItems'
      },
      {
        title: 'orderDishesGroupConfig',
        icon: 'mdi-credit-card-edit',
        to: 'orderDishesGroup'
      }
      // {
      //   title: 'printer',
      //   group: '/settings',
      //   icon: 'mdi-printer',
      //   children: [
      //     {
      //       icon: 'mdi-printer',
      //       title: 'printerInfo',
      //       to: 'print/section-printer-setting',
      //     },
      //     {
      //       icon: 'mdi-file-find',
      //       title: 'operationRecords',
      //       to: 'settings/operationlist',
      //     },
      //     {
      //       icon: 'mdi-file-find',
      //       title: 'print_bill_list',
      //       to: 'print/printRecordlist',
      //     }, {
      //       icon: 'mdi-note-edit',
      //       title: 'printTemplate',
      //       to: 'print/bon-template',
      //     }, {
      //       icon: 'mdi-note-edit',
      //       title: 'freeInfoSheet',
      //       to: 'settings/freeInfoSheet',
      //     },
      //   ],
      // },
      // {
      //   group: '/settings',
      //   title: 'storesInformation',
      //   icon: 'mdi-dots-horizontal-circle-outline',
      //   children: [
      //     {
      //       title: 'restaurantImage',
      //       icon: 'mdi-panorama-variant',
      //       to: 'restaurant-image',
      //     }, {
      //       title: 'selfServiceOrderingMachine',
      //       icon: 'mdi-image-size-select-actual',
      //       to: 'banner-image',
      //     },
      //   ],
      // },
      // {
      //   group: '/settings',
      //   icon: 'mdi-account-edit',
      //   title: 'marketLabel',
      //   children: [
      //     {
      //       title: 'ingredientSetting',
      //       icon: 'mdi-food-outline',
      //       to: 'marketLabel/ingredientSetting',
      //     }, {
      //       title: 'ingredientSelect',
      //       icon: 'mdi-food-apple',
      //       to: 'marketLabel/ingredientSelect',
      //     }, {
      //       title: 'SettingSKU',
      //       icon: 'mdi-note-check',
      //       to: 'marketLabel/SettingSKU',
      //     },
      //   ],
      // },
    ]
  },
  {
    group: '/datev',
    desc: '',
    icon: 'mdi-format-list-checks',
    iconFx: 'mdi-format-list-checks',
    title: 'DataAccess',
    children: [
      {
        title: 'BindDatev',
        icon: 'mdi-store-cog-outline',
        to: 'datevManage'
      },
      {
        title: 'DatevDownloadTitle',
        icon: 'mdi-store-cog-outline',
        to: 'datevDownload'
      }
    ]
  },
  {
    group: '/vip',
    desc: '',
    icon: 'mdi-human-male',
    iconFx: 'mdi-human-male',
    title: 'vipManage',
    children: [
      {
        title: 'vipManage',
        icon: 'mdi-store-cog-outline',
        to: 'VipManage'
      },
      {
        title: 'DiscountArea',
        icon: 'mdi-store-cog-outline',
        to: 'Discount'
      },
      {
        title: 'recharge',
        icon: 'mdi-store-cog-outline',
        to: 'Pay'
      },
      {
        title: 'PointsSettings',
        icon: 'mdi-store-cog-outline',
        to: 'PointSetting'
      },
      {
        title: 'vipLevel',
        icon: 'mdi-store-cog-outline',
        to: 'Level'
      }
    ]
  },
  {
    group: '/products',
    desc: '',
    needWifi: true,
    icon: 'mdi-store',
    iconFx: 'mdi-store',
    title: 'ProductCenter',
    children: [
      {
        title: 'ProductCenter',
        icon: 'mdi-store-cog-outline',
        to: 'productsInfo'
      }
    ]
  },
  {
    group: '/admin',
    desc: '',
    icon: 'mdi-heart-pulse',
    iconFx: 'mdi-heart-pulse',
    admin: true,
    title: 'Admin',
    children: [
      {
        title: 'BillTotal',
        icon: 'mdi-credit-card-edit',
        to: 'BillTotal'
      },
      {
        icon: 'mdi-file-find',
        title: 'APIDataAccess',
        to: 'operationlist'
      }
    ]
  }
  // {
  //   group: '/manual',
  //   desc: 'HelpDesc',
  //   id: null,
  //   icon: 'mdi-book-open-page-variant-outline',
  //   title: 'HelpManual',
  //   children: [{
  //     title: 'HelpManual',
  //     icon: 'mdi-text',
  //     to: '/',
  //   }],
  // },
]

export async function productIsReadyForStore (code) {
  let ready = true
  switch (code) {
    case ProductCodes.reservation:
      ready = await reservationReady()
  }
  return ready
}

export function productActivatePage (code) {
  switch (code) {
    case ProductCodes.reservation:
      return '/reserve/openReserve'
    case ProductCodes.takeawayWeb:
      return '/TakeawayWeb/takeawayWeb'
  }
}

export const bubbleTeaMenu = restaurantMenu
